import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';
import { Image } from '../../../';

const TopAccordion = ({ data }) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const onAccordionClick = (index) => {
		setActiveIndex(index);
	};

	return (
		<div
			className='topAccordion md:pb-14 md:pt-10 xl:pb-16 xl:pt-12'
			data-testid='top-accordion'
		>
			<Container>
				<div className='grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2'>
					{data.heading && <h1 className='text-h2 col-start-1 row-start-1 m-0 max-w-[16ch] md:row-start-2'>{data.heading}</h1>}

					<div className='topAccordion-tabs col-start-1 row-start-3 gap-x-4 space-y-[1.125rem] md:row-start-3 md:space-y-5 xl:space-y-6'>
						{data.content_sections.map((section, index) => (
							<button
								key={index}
								type='button'
								className={`sl-contentSection block border-l-[5px] pl-6 text-left ${index === activeIndex ? 'border-primary' : 'border-gray-15 py-2.5'}`}
								onClick={() => onAccordionClick(index)}
							>
								{section.heading && <h3 className='m-0'>{section.heading}</h3>}
								{section.description && (
									<p
										className={`mt-2 text-gray-90 md:mt-2.5 xl:mt-3 ${index === activeIndex ? 'block' : 'hidden'}`}
										dangerouslySetInnerHTML={{ __html: section.description }}
									/>
								)}
							</button>
						))}
					</div>

					<div className='topAccordion-image col-start-1 row-start-2 self-center md:col-start-2 md:row-span-4 md:row-start-1'>
						{data.content_sections.map((section, index) => (
							<Image
								key={index}
								data={section.image[0]}
								loading='eager'
								className={index !== activeIndex ? '!hidden' : ''}
							/>
						))}
					</div>
				</div>
			</Container>
		</div>
	);
};

TopAccordion.propTypes = {
	data: PropTypes.object.isRequired,
};

export default TopAccordion;
